import React, { useState } from "react"
import { Label, Input, Form } from "reactstrap"

import ImageManipulator from "./ImageManipulator"

const maxFileSize = 20097152

const QuestionImageManipulator = props => {
    const { t, file, setFile, setModal, fileUrl, setImageChanged } = props

    const [imagePreviewUrl, setImagePreviewUrl] = useState("")

    const handleImageChange = e => {
        e.preventDefault()

        let reader = new FileReader()
        let newFile = e.target.files[0]

        if (!newFile) return

        if (newFile.size > maxFileSize) {
            setModal({
                type: "danger",
                message: t('file_cant_be_larger'),
            })
            return
        }

        reader.onloadend = () => {
            setImageChanged(true)
            setFile(newFile)
            setImagePreviewUrl(reader.result)
        }

        if (newFile) {
            reader.readAsDataURL(newFile)
        }
    }

    const imagePreviewContainer = imagePreviewUrl || fileUrl
        ? <ImageManipulator
            imagePreviewUrl={imagePreviewUrl}
            t={t}
            {...props}
        />
        : null

    return (
        <div>
            <Form className="mb-2">
                <p className="font-weight-bold mb-2">{t("question_image")}</p>
                <Input
                    type="file"
                    id="uploadFileBtn"
                    className="d-none"
                    onChange={handleImageChange}
                    accept="image/x-png,image/jpeg"
                />
                <Label
                    htmlFor="uploadFileBtn"
                    role="button"
                    tabIndex={0}
                    style={{
                        padding: "4px",
                        marginBottom: 0,
                        border: "1px solid #20a8d8",
                        backgroundColor: "#20a8d8",
                        borderRadius: "2px",
                        color: "#fff",
                        fontWeight: 500,
                        fontSize: "0.9em",
                        cursor: "pointer"
                    }}
                    onMouseEnter={e => {
                        e.target.style.backgroundColor = "#1b8eb7";
                        e.target.style.border = "1px solid #1985ac";
                    }}

                    onMouseLeave={e => {
                        e.target.style.backgroundColor = "#20a8d8";
                        e.target.style.border = "1px solid #20a8d8";
                    }} >
                    <i className="fa fa-paperclip mr-1" aria-hidden="true"></i>
                    {imagePreviewUrl || fileUrl ? t("change_file") : t("choose_file")}
                </Label>
            </Form>
            {imagePreviewContainer}
        </div>
    )
}

export default QuestionImageManipulator
